<template>

  <nav class="nav">

    <div class="nav__logo">

      <router-link
        to="/"
        exact
        class="logo logo_inside_nav"
      >

        <div class="logo__image"></div>
      
        <div class="logo__caption">Trade<br>marketing</div>

      </router-link>

    </div>

    <div class="nav__container">

      <div class="nav__items">

        <template v-for="(item, indexItem) in items">

          <div
            v-if="item.subitems !== null"
            class="nav-item nav-item_subitems"
          >

            <div
              @click="onClickItemName"
              class="nav-item__name"
            >{{ item.name }}</div>

            <div
              v-if="item.subitems !== null"
              class="nav-item__subitems"
            >
              
              <div
                v-for="(subitem, indexSubitem) in item.subitems"
                class="nav-subitem"
              >
              
                <router-link
                  :to="subitem.link"
                  @click.native="onClickSubitemName"
                  class="nav-subitem__name"
                >{{ subitem.name }}</router-link>

            </div>

            </div>

          </div>

          <div
            v-else
            class="nav-item"
          >

            <template v-if="getItems(item)">
              <router-link
                      :to="item.link"
                      @click.native="onClickItemName"
                      class="nav-item__name"
              >{{ item.name }}</router-link>
            </template>

          </div>

        </template>

      </div>
      
      <div class="nav__contacts">

        <router-link
          to="/career"
          class="link link_work-with-us"
        >Work with us</router-link>
        
        <div class="social-networks social-networks_nav">

          <a href="//www.youtube.com/4mktg" target="_blank" class="social-networks__item social-networks__item_youtube social-network social-network_nav">
          
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 17">

              <path class="social-network__content" fill-rule="nonzero" d="M18.78 0H4.923C2.203 0 0 2.234 0 4.99v7.02C0 14.767 2.204 17 4.923 17H18.78c2.72 0 4.923-2.234 4.923-4.99V4.99C23.703 2.233 21.5 0 18.78 0zm-3.33 8.842l-6.48 3.133c-.173.083-.373-.044-.373-.238V5.275c0-.197.205-.325.378-.236l6.48 3.328c.194.1.19.38-.004.474z"></path>

            </svg>
          
          </a>

          <a href="//twitter.com/4MKTG" target="_blank" class="social-networks__item social-networks__item_twitter social-network social-network_nav">
            
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 19">
          
              <path class="social-network__content" fill-rule="nonzero" d="M23 2.248c-.847.38-1.755.64-2.71.756.975-.594 1.72-1.535 2.075-2.653-.914.55-1.923.95-2.998 1.166C18.507.582 17.28 0 15.923 0c-2.606 0-4.718 2.15-4.718 4.797 0 .376.04.743.122 1.093-3.92-.2-7.398-2.11-9.725-5.013C1.196 1.584.964 2.41.964 3.29c0 1.664.834 3.132 2.1 3.992C2.288 7.256 1.56 7.04.925 6.68v.06c0 2.324 1.627 4.263 3.784 4.705-.395.108-.812.168-1.243.168-.305 0-.6-.03-.89-.09.602 1.908 2.344 3.295 4.408 3.333-1.614 1.286-3.65 2.05-5.86 2.05-.38 0-.756-.022-1.125-.065C2.088 18.206 4.568 19 7.232 19c8.68 0 13.424-7.31 13.424-13.652l-.016-.62c.927-.673 1.73-1.518 2.36-2.48z"></path>
          
            </svg>

          </a>

          <a href="//facebook.com/4MKTG.For.Marketing/" target="_blank" class="social-networks__item social-networks__item_facebook social-network social-network_nav">
            
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 24">

              <path class="social-network__content" fill-rule="nonzero" d="M2.378 4.648v3.304H0v4.04h2.378V24h4.884V11.993h3.277s.306-1.937.455-4.056H7.28V5.175c0-.413.533-.97 1.06-.97H11V0H7.382C2.257 0 2.378 4.044 2.378 4.648z"></path>
            
            </svg>

          </a>
          
        </div>

      </div>

    </div>

  </nav>

</template>

<script>

  export default {
    name: 'TheNavigation',

    data() {
      return {
        items: [
          {
            link: null,
            name: 'Our services',
            subitems: [
              {
                link: '/horeca',
                name: 'HoReCa',
              },
              {
                link: '/gdo',
                name: 'Presidio GDO',
              },
              {
                link: '/logistics',
                name: 'Logistics',
              },
              {
                link: '/events',
                name: 'Events',
              },
              {
                link: '/creative',
                name: 'Creative',
              },
            ],
          },
          {
            link: '/about',
            name: 'About us',
            subitems: null,
          },
          {
            link: '/career',
            name: 'Career',
            subitems: null,
          },
          {
            link: '/news',
            name: 'News',
            subitems: null,
          },
          {
            link: '/contacts',
            name: 'Contacts',
            subitems: null,
          },
        ],
        news: [],
        loading: false,
      };
    },

    created() {
      this.switchClasses(true);
      this.getNews();
    },

    beforeDestroy() {
      this.switchClasses(false);
    },

    methods: {
      onClickItemName(e) {
        const node = e.currentTarget;
        const submenuNode = node.closest('.nav-item_subitems');
        const isSubmenu = submenuNode !== null;
        const isCurrentRoute = node.closest('.link_exact') !== null;

        if (isSubmenu) {
          this.toggleVisibilitySubmenu(submenuNode);
        } else if (isCurrentRoute) {
          this.hide();
        }
      },

      onClickSubitemName(e) {
        const node = e.currentTarget;
        const submenuNode = node.closest('.nav-item_subitems');
        const isSubmenu = submenuNode !== null;
        const isCurrentRoute = node.closest('.link_exact') !== null;

        if (isSubmenu) {
          this.toggleVisibilitySubmenu(submenuNode);
        }

        if (isCurrentRoute) {
          this.hide();
        }
      },

      toggleVisibilitySubmenu(submenu) {
        const cssClass = 'nav-item_open';
        const condition = submenu.classList.contains(cssClass);

        if (condition) {
          submenu.classList.remove(cssClass);
        } else {
          submenu.classList.add(cssClass);
        }
      },

      hide() {
        this.$emit('hide');
      },

      switchClasses(isOpen) {
        const nodes = [
          document.documentElement,
          document.body,
        ];

        const cssClass = 'nav-open';

        nodes.forEach((node) => {
          if (isOpen) {
            node.classList.add(cssClass);
          } else {
            node.classList.remove(cssClass);
          }
        });
      },

      getNews() {
        this.$http.get('/api/news').then((response) => {
            this.loading = true;
            this.news = response.data.news;
        }, function(error) {
            console.log(error.statusText);
        });
      },

      getItems(item) {
        if (item.name == 'News') {
            if (!!this.news) {
                if (this.news.length == 0) {
                    return false;
                }
            } else {
                if (!this.news) {
                    return false;
                }
            }
        }

        return true;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/TheNavigation.vue